<!--
图标

使用说明：

<Icon
 :img="'图片路径'"
 :size="类型，可选cover / contain"
 />

-->

<template>
    <div class="icon-wrap">
        <div class="icon" :class="[size]" :style="{backgroundImage:'url(' + img + ')'}"></div>
    </div>
</template>

<script>
export default {
  props: ["img", "size"]
};
</script>

<style lang="less" scoped>
.icon-wrap {
  display: inline-block;
}

.icon {
  display: block;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;

  &.cover {
    background-size: cover;
    border-radius: 10px;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/common/Icon.vue